import { gql, TypedDocumentNode } from "@apollo/client";

import { AiModel, QueryBedrockInferenceProfilesArgs } from "types/generated";

type BedrockInferenceProfileView = Pick<AiModel, "id" | "name">;

type SearchBedrockInferenceProfilesData = {
  bedrockInferenceProfiles: BedrockInferenceProfileView[];
};

export const SEARCH_BEDROCK_INFERENCE_PROFILES: TypedDocumentNode<
  SearchBedrockInferenceProfilesData,
  QueryBedrockInferenceProfilesArgs
> = gql`
  query SearchBedrockInferenceProfiles($awsIntegration: ID!, $config: AWSBedrockConfigInput!) {
    bedrockInferenceProfiles(awsIntegration: $awsIntegration, config: $config) {
      id
      name
    }
  }
`;
